import '@/styles/quasar.scss'
import '@quasar/extras/mdi-v7/mdi-v7.css'

import { watch } from 'vue'
import iconSet from 'quasar/icon-set/mdi-v7.js'
import Lang from 'quasar/src/plugins/lang/Lang.js';
import it from 'quasar/lang/it'
import en from 'quasar/lang/en-US'
import fr from 'quasar/lang/fr'
import de from 'quasar/lang/de'
import es from 'quasar/lang/es'

import { useDetectDevice } from '@/composables/device'
import i18n from '@/plugins/i18n'
const { isMobile } = useDetectDevice()

const quasarLangMap = {
  it,
  en,
  fr,
  de,
  es
}

export const initQuasarLang = () => {
  watch(
    () => i18n.global.locale.value,
    (val) => {
      Lang.set(quasarLangMap[val] || en)
    },
    { immediate: true }
  )
}

import QBtn from 'quasar/src/components/btn/QBtn.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import QList from 'quasar/src/components/item/QList.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QInput from 'quasar/src/components/input/QInput.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QCard from 'quasar/src/components/card/QCard.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QStep from 'quasar/src/components/stepper/QStep.js';import QImg from 'quasar/src/components/img/QImg.js';import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QStepper from 'quasar/src/components/stepper/QStepper.js';import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';import QForm from 'quasar/src/components/form/QForm.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QPage from 'quasar/src/components/page/QPage.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QChip from 'quasar/src/components/chip/QChip.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import Notify from 'quasar/src/plugins/notify/Notify.js';import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QTab from 'quasar/src/components/tabs/QTab.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QFooter from 'quasar/src/components/footer/QFooter.js';import QSplitter from 'quasar/src/components/splitter/QSplitter.js';import QField from 'quasar/src/components/field/QField.js';import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';import QBanner from 'quasar/src/components/banner/QBanner.js';import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import QFab from 'quasar/src/components/fab/QFab.js';import QFabAction from 'quasar/src/components/fab/QFabAction.js';import QDate from 'quasar/src/components/date/QDate.js';import QTime from 'quasar/src/components/time/QTime.js';import QSpinner from 'quasar/src/components/spinner/QSpinner.js';

const setDefaults = (elem, opts) => {
  const props = elem.props
  Object.keys(opts).forEach(key => {
    props[key] = {
      type: props[key],
      default: opts[key]
    }
  })
}

setDefaults(QInput, {
  outlined: true,
  hideBottomSpace: true,
})

setDefaults(QDialog, {
  transitionShow: isMobile.value ? 'slide-left' : 'scale',
  transitionHide: isMobile.value ? 'slide-right' : 'scale',
})

setDefaults(QSelect, {
  outlined: true,
  hideBottomSpace: true,
})

setDefaults(QCard, {
  flat: true,
  bordered: true
})

export default {
  components: [QBtn, QToolbar, QSpace, QBtnDropdown, QList, QSelect, QInput, QSeparator, QCardSection, QCard, QDialog,
      QStep, QImg, QInnerLoading, QItemLabel, QAvatar, QItem, QItemSection, QStepper, QStepperNavigation, QForm, QToggle,
      QPage, QPageContainer, QLayout, QChip, QIcon, QDrawer, QHeader, QBtnGroup, QInfiniteScroll, QTabs, QTab, QBadge,
      QMenu, QFooter, QSplitter, QField, QBtnToggle, QBanner, QLinearProgress, QFab, QFabAction, QDate, QTime, QSpinner],
  config: {
    notify: {
      position: 'top-right',
      timeout: 3000,
      textColor: 'white',
      progress: true
    },
    iconMapFn: (iconName) => {
      const map = {
        'search': { icon: 'mdi-magnify' },
      }
      return map[iconName]
    }
  },
  plugins: {
    Notify, Dialog
  },
  iconSet: iconSet

}
